// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT_PROFILE: `Profil du compte`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADA_TOGGLE_ON: `Appuyer pour activer la hauteur d'écran réduite`,
    ADA_TOGGLE_OFF: `Appuyer pour désactiver la hauteur d'écran réduite`,
    ADD: `Ajouter`,
    ADD_DONATION: `Ajouter un don`,
    ADD_FUNDS: `Ajouter des fonds`,
    ADD_TIP: `Ajouter un pourboire`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Ajouter à la commande`,
    ADD_NEW: `Ajouter nouveau`,
    ADDED: `Ajouté`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Ajouté à la commande`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Saisissez votre choix.`,
    ADDRESS_CITY: `Ville`,
    ADDRESS_LINE_1: `Adresse`,
    ADDRESS_LINE_2: `Apt, Étage, Suite, Bâtiment, Entreprise (Facultatif)`,
    ADDRESS_POSTAL_CODE: `Code postal`,
    ALCOHOL_VERIFICATION: `Vérification d'alcool`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `Vous pourriez aussi aimer...`,
    APPLIED_STORED_VALUE_CARDS: `Cartes-cadeaux`,
    ASAP: `Dès que possible`,
    AT_LEAST_X: `au moins {{$1: number}}`,
    BACK: `Retour`,
    BACK_TO_MENU: `Retour au menu`,
    BACK_TO_MENU_FROM_LOYALTY: `Retour au menu`,
    BACK_TO_CART: `Retour au panier`,
    BACK_TO_PAYMENT_OPTIONS: `Retour aux options de paiement`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Retour aux options de paiement`,
    BAD_ACCESS_CODE: `Code d'accès incorrect`,
    BALANCE: `Solde`,
    BAG_OPT_IN_PROMPT: `Souhaitez-vous ajouter un sac à emporter à votre commande ?`,
    BAG_OPT_IN_TITLE: `Ajouter un sac ?`,
    BAG_OPT_IN: `Oui, je voudrais un sac`,
    BAG_OPT_OUT: `Non, merci`,
    BLOCKED_WORD_WARNING: `Veuillez supprimer les mots bloqués`,
    CALORIES: `Calories`,
    CANCEL: `Annuler`,
    CANCEL_CHECKOUT: `Annuler`,
    CASH: `Caissier`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Carte enregistrée`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Contactless`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Saisi manuellement`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Fourni en externe`,
    CARD_ENTRY_SCAN: `Scanner`,
    CARD_ENTRY_SWIPE: `Glisser`,
    CARD_ENTRY_UNKNOWN: `Inconnu`,
    CARD_EXPIRED: `Carte expirée`,
    CARD_EXPIRING: `Votre carte expire bientôt`,
    CART: `Panier`,
    CART_LABEL: `Aller au panier avec {{$1: number}} articles pour {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Modifier l'article`,
    CHANGE_PASSWORD: `Modifier le mot de passe`,
    CHANGE_PASSWORD_SUCCESS: `Votre mot de passe a été mis à jour.`,
    CHARS_LEFT: `{{$1: number}} caractères restants`,
    CHECK_AMOUNT: `Vérification du montant...`,
    CHECKOUT: `Payer`,
    CHECKOUT_STEP_CART: `Panier`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Paiement`,
    CHECKOUT_STEP_PAYING: `Paiement en cours`,
    CHECKOUT_STEP_DONE: `Terminé`,
    CHECKOUT_WITH_FORCED_MENU: `Impossible de procéder au paiement lors de l'affichage d'un aperçu du menu. Le paiement n'est disponible que lors de l'affichage du menu "Actuellement affiché".`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `Choisir une option`,
    CHOOSE_TIME_SLOT: `Veuillez choisir un créneau horaire :`,
    CLEAR_ALL: `Tout effacer`,
    CLEARING_SESSION: `Préparation du kiosque pour le prochain client...`,
    CLOSE: `Fermer`,
    CLOSED_SCREEN_MESSAGE: `Désolé, nous sommes fermés ou n'acceptons pas les commandes mobiles.`,
    CONFIRM: `Confirmer`,
    CONFIRM_ADDRESS: `Confirmer l'adresse`,
    CONFIRM_DISCARD: `Supprimer l'article ?`,
    CONFIRM_DISCARD_CHANGES: `Êtes-vous sûr de vouloir annuler vos modifications ?`,
    CONFIRM_YOUR_ITEM: `Confirmez votre article`,
    CONFIRM_QUIT: `Êtes-vous sûr de vouloir quitter ?`,
    CONFIRM_REFUND_AMOUNT: `Êtes-vous sûr de vouloir rembourser {{$1: dollar amount}} de cette transaction ?`,
    CONFIRMING_YOUR_CARD: `Confirmation de votre carte...`,
    CONTINUE: `Continuer`,
    CONTINUE_AS_GUEST: `Continuer en tant qu'invité`,
    COULD_WE_INTEREST: `Ceci pourrait vous intéresser...`,
    COMP_CARD: `Carte de courtoisie`,
    COMP_CARD_SCAN: `Scanner la carte de courtoisie`,
    COMP_CARD_SCAN_FAILED_TITLE: `Échec du scan de la carte de courtoisie`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Une erreur s'est produite lors du scan de la carte de courtoisie. Veuillez réessayer.`,
    COMP_CARD_APPLYING_TITLE: `Application de la carte de courtoisie`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Erreur d'application de la carte de courtoisie`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Une erreur s'est produite lors de l'application de la carte de courtoisie. Veuillez réessayer.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Veuillez saisir un numéro de carte de courtoisie`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Veuillez saisir un numéro de carte de courtoisie valide`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Veuillez saisir un numéro de carte de courtoisie valide`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Veuillez saisir un code PIN de carte de courtoisie`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Veuillez saisir un code PIN de carte de courtoisie valide`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Veuillez saisir un code PIN de carte de courtoisie valide`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Saisissez le numéro de votre carte de courtoisie. Les numéros peuvent comporter {{$1: number}} chiffres.`,
    COMP_CARD_ENTERING_PIN_HINT: `Saisissez le code PIN de votre carte de courtoisie. Les numéros peuvent comporter {{$1: length}} chiffres.`,
    COMP_CARD_ERROR_REMOVING: `Une erreur s'est produite lors de la suppression de la carte de courtoisie. Veuillez réessayer.`,
    'bottom-bar.storm-toggle.on': `Appuyer pour activer la navigation Storm`,
    'bottom-bar.storm-toggle.off': `Appuyer pour désactiver la navigation Storm`,
    'campus-card.label': `Carte du campus`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Appuyer pour payer avec une carte du campus`,
    'campus-card.scan': `Scannez votre carte du campus`,
    'campus-card.scan-failed.title': `Échec du scan de la carte du campus`,
    'campus-card.scan-failed.message': `Une erreur s'est produite lors du scan de la carte du campus. Veuillez réessayer.`,
    'campus-card.enter-number': `Saisissez votre numéro de carte du campus`,
    'campus-card.enter-pin': `Saisissez votre code PIN de carte du campus`,
    'campus-card.applying.title': `Application de la carte du campus`,
    'campus-card.applying.error.title': `Erreur d'application de la carte du campus`,
    'campus-card.applying.error.message': `Une erreur s'est produite lors de l'application de la carte du campus. Veuillez réessayer.`,
    'campus-card.entering-number.error.required': `Veuillez saisir un numéro de carte du campus`,
    'campus-card.entering-number.error.invalid': `Veuillez saisir un numéro de carte du campus valide`,
    'campus-card.entering-number.error.length': `Veuillez saisir un numéro de carte du campus valide`,
    'campus-card.entering-number.hint': `Saisissez votre numéro de carte du campus. Les numéros peuvent comporter {{$1: number}} chiffres.`,
    'campus-card.entering-pin.error.required': `Veuillez saisir un code PIN de carte du campus`,
    'campus-card.entering-pin.error.invalid': `Veuillez saisir un code PIN de carte du campus valide`,
    'campus-card.entering-pin.error.length': `Veuillez saisir un code PIN de carte du campus valide`,
    'campus-card.entering-pin.hint': `Saisissez le code PIN de votre carte du campus. Les numéros peuvent comporter {{$1: length}} chiffres.`,
    'campus-card.error-removing': `Une erreur s'est produite lors de la suppression de la carte du campus. Veuillez réessayer.`,
    'campus-card.no-balance.title': `Aucun solde disponible`,
    'campus-card.no-balance.message': `Il n'y a pas de solde disponible sur cette carte du campus.`,
    'campus-card.add-another': `Ajouter une autre`,
    'campus-card.remove': `Supprimer la carte du campus`,
    'campus-card.select-account.title': `Sélectionner un compte`,
    'campus-card.select-account.loading': `Chargement des comptes...`,
    'campus-card.select-account.error.title': `Impossible de charger les comptes`,
    'campus-card.select-account.error.message': `Nous n'avons pas pu charger vos comptes. Veuillez réessayer.`,
    'campus-card.select-account.column.account': `Compte`,
    'campus-card.select-account.column.balance': `Solde actuel`,
    'campus-card.select-account.error.toast-title': `Erreur`,
    'campus-card.select-account.error.toast-message': `Échec de la validation. Veuillez réessayer.`,
    'campus-card.swipe': `Glissez votre carte du campus pour payer`,
    COUPON: `Coupon`,
    COUPON_ALREADY_USED: `Le code coupon a déjà été utilisé.`,
    COUPON_MIN_SPEND_NOT_MET: `Le code coupon saisi ne répond pas à l'exigence de dépense minimale.`,
    COUPON_NOT_FOUND: `Code coupon introuvable.`,
    COUPON_NOT_ACCEPTED: `Le code coupon saisi n'a pas été accepté.`,
    COUPON_APPLYING: `Application du coupon`,
    COUPON_APPLYING_ERROR_TITLE: `Erreur d'application du coupon`,
    COUPON_APPLYING_ERROR_MESSAGE: `Une erreur s'est produite lors de l'application du coupon. Veuillez réessayer.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `Le code coupon saisi ne répond pas aux exigences de la commande.`,
    COUPON_SCANNING_ERROR_TITLE: `Erreur de scan du coupon`,
    COUPON_SCANNING_ERROR_MESSAGE: `Une erreur s'est produite lors du scan du coupon. Veuillez réessayer.`,
    COUPON_ENTERING_ERROR_LENGTH: `Veuillez saisir un code coupon.`,
    COUPON_ENTERING_ERROR_INVALID: `Veuillez saisir un code coupon valide.`,
    COUPON_ERROR_REMOVING: `Une erreur s'est produite lors de la suppression du coupon. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    CREATE_A_NEW_ACCOUNT: `Créer un nouveau compte`,
    CREATE_ACCOUNT: `Créer un compte`,
    CREATE_ACCOUNT_TERMS_LINE: `En créant un compte, vous acceptez les`,
    CREDIT_CARD: `Carte de crédit`,
    CREDIT_CARD_NUMBER: `Numéro de carte`,
    CURBSIDE: `Collecte en bordure de trottoir`,
    CURRENT_PASSWORD: `Mot de passe actuel`,
    CUSTOM_TIP: `Personnalisé`,
    CUSTOM_TIP_INVALID: `Veuillez saisir un montant de pourboire valide.`,
    CUSTOM_TIP_HINT: `Saisissez le montant de votre pourboire. Maximum : {{$1: number}}`,
    CUSTOM_DONATION: `Don personnalisé`,
    CUSTOMER_CARDS: `Utiliser une carte enregistrée`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Se connecter`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Votre compte`,
    CUSTOMIZE: `Personnaliser`,
    DEBIT: `Débit`,
    DEBIT_CREDIT_CARD: `Carte débit/crédit`,
    DEMO_PAY: `Démo : Payer`,
    DELIVERY: `Livraison`,
    DELIVERY_ADDRESS: `Adresse de livraison`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `Supprimer {{$1: mod name}}`,
    DINE_IN: `Sur place`,
    DISCLAIMER_EMAIL: `L'utilisation de l'adresse e-mail est soumise aux conditions d'utilisation.`,
    DISCLAIMER_PHONE: `L'utilisation du numéro de téléphone est soumise aux conditions d'utilisation.`,
    DISCLAIMER_PHONE_LINK: `CONDITIONS D'UTILISATION :`,
    DISCLAIMER_PHONE_DESCRIPTION: `POUR L'UTILISATION DU NUMÉRO DE TÉLÉPHONE`,
    DISCLAIMER_NAME: `Votre nom sera utilisé pour confirmer votre commande et faciliter le retrait au point désigné.`,
    DISCOUNTS: `Réductions`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Les réductions seront appliquées au moment du paiement`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `La réduction sera appliquée au moment du paiement`,
    DONATION: `Don`,
    DONATION_APPLYING: `Application du don...`,
    DONATION_APPLY_ERROR_TITLE: `Erreur d'application du don`,
    DONATION_APPLY_ERROR_MESSAGE: `Une erreur s'est produite lors de l'application de votre don. Veuillez réessayer.`,
    DONATION_FAILED: `Le don a échoué. Veuillez réessayer.`,
    DONATION_ROUND_UP_TITLE: `Souhaitez-vous arrondir votre total ?`,
    DONATION_ROUND_UP_TO: `Arrondir à {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `Souhaitez-vous arrondir votre total au dollar le plus proche ?`,
    DONATION_ROUND_UP_ACCEPT: `Oui, arrondir`,
    DONATION_ROUND_UP_REJECT: `Non, merci`,
    DONATION_REMOVE: `Supprimer le don`,
    DONE: `Terminé`,
    DONT_INCLUDE_UTENSILS: `Ne pas inclure les couverts`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `Remboursement EBT`,
    EBT_CHOICE_DIALOG_TITLE: `Quelle méthode EBT souhaitez-vous utiliser ?`,
    EBT_CHOICE_CASH_BENEFIT: `Prestation en espèces`,
    EBT_CHOICE_FOOD_STAMPS: `Bons alimentaires`,
    EBT_CARD_SUBTITLE: `Glissez votre carte EBT sur le terminal de paiement`,
    EDIT: `Modifier`,
    EDIT_ORDER: `Modifier la commande`,
    EDIT_TIP: `Modifier le pourboire`,
    SAVE_ORDER: `Enregistrer la commande`,
    EMAIL_ADDRESS: `Adresse e-mail`,
    EMAIL_RECEIPT: `Reçu par e-mail`,
    EMAIL_REQUIRED_FOR_RECEIPT: `Un e-mail est requis pour votre reçu.`,
    EMAIL_RECEIPT_SEND_FAILED: `Impossible d'envoyer le reçu. Veuillez réessayer.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Reçu envoyé avec succès.`,
    ENTER_ACCESS_CODE: `Saisissez le code d'accès :`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `Saisissez votre e-mail`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `Impossible de scanner ? Saisissez votre numéro de carte.`,
    ENTER_PHONE_CONSENT: `Je consens à recevoir des communications marketing par SMS.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Saisissez votre numéro de téléphone`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Bonjour {{$1 guest name}}, veuillez saisir votre numéro de téléphone`,
    ENTER_PHONE_LOYALTY: `Saisissez votre numéro de téléphone mobile`,
    ENTER_PHONE_RECEIPT: `Saisissez votre numéro de téléphone mobile pour recevoir un reçu`,
    ENTER_PHONE_TEXT_WHEN_READY: `Saisissez votre numéro de téléphone pour recevoir un SMS quand votre commande est prête !`,
    ENTER_VEHICLE_DESCRIPTION: `Veuillez saisir les détails de votre véhicule pour que nous puissions vous apporter votre commande :`,
    ENTER_YOUR_COUPON_CODE: `Saisissez votre code coupon`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Saisissez votre numéro de carte de courtoisie`,
    ENTER_YOUR_COMP_CARD_PIN: `Saisissez votre code PIN de carte de courtoisie`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Saisissez votre numéro de carte-cadeau`,
    ENTER_YOUR_GIFT_CARD_PIN: `Saisissez votre code PIN de carte-cadeau`,
    ENTER_YOUR_EMAIL: `Saisissez votre e-mail :`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `E-mail invalide. Veuillez réessayer.`,
    ENTER_YOUR_FIRST_NAME: `Saisissez votre prénom :`,
    ENTER_YOUR_LAST_NAME: `Saisissez l'initiale de votre nom de famille :`,
    ENTER_YOUR_NAME: `Saisissez votre nom :`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Nom invalide. Veuillez réessayer.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `Veuillez saisir un nom.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `Une seule lettre est autorisée. Veuillez réessayer.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `Le nom ne doit contenir que des lettres. Veuillez réessayer.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `Le nom contient des mots inappropriés. Veuillez réessayer.`,
    ERROR: `Oups !`,
    ERROR_ADDING_ITEM: `Une erreur s'est produite lors de l'ajout de l'article à votre panier. Veuillez réessayer. Si le problème persiste, demandez de l'aide au membre de l'équipe le plus proche.`,
    ERROR_EDITING_ITEM: `Une erreur s'est produite lors de la modification de l'article dans votre panier. Veuillez réessayer. Si le problème persiste, demandez de l'aide au membre de l'équipe le plus proche.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `Le montant dépasse le solde de la carte.`,
    ERROR_CARD_CONFIRMATION: `Désolé ! Impossible de confirmer la carte. Veuillez réessayer.`,
    ERROR_CARD_DECLINED: `Impossible de débiter la carte indiquée. Veuillez réessayer.`,
    ERROR_CARD_INACTIVE: `Désolé, cette carte étudiant n'est pas active.`,
    ERROR_CARD_NOT_FOUND: `Désolé ! Nous n'avons pas pu trouver cette carte. Veuillez réessayer.`,
    ERROR_CARD_NUMBER_LENGTH: `Le numéro de carte n'a pas la bonne longueur.`,
    ERROR_CARD_RESTRICTED_TIME: `Désolé, cette carte ne peut pas être utilisée en ce moment.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Désolé, {{$1: cardScheme}} n'est pas accepté ici. Pourriez-vous essayer une autre carte ?`,
    ERROR_COUPON_CONFIRMATION: `Désolé ! Impossible d'utiliser le code coupon. Veuillez réessayer.`,
    ERROR_INVALID_EMAIL: `Adresse e-mail invalide`,
    ERROR_INVALID_LOGIN_CREDS: `Nom d'utilisateur ou mot de passe invalide`,
    ERROR_INVALID_NAME: `Veuillez saisir un nom valide`,
    ERROR_INVALID_PHONE_NUMBER: `Veuillez saisir un numéro de téléphone valide`,
    ERROR_INVALID_ROOM_NUMBER: `Veuillez saisir un numéro de chambre valide`,
    ERROR_INVALID_TABLE_NUMBER: `Veuillez saisir un numéro de table valide`,
    ERROR_INVALID_VERIFICATION_CODE: `Code de vérification invalide`,
    ERROR_KIOSK_CARD_DECLINED: `Une erreur s'est produite. Votre carte n'a pas été débitée. Veuillez réessayer.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `Impossible de lire la carte. Veuillez réessayer.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `Le kiosque n'a pas pu trouver le terminal de paiement. Votre carte n'a pas été débitée. Veuillez contacter un membre du personnel.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `Le terminal de paiement semble hors ligne. Votre carte n'a pas été débitée. Veuillez contacter un membre du personnel.`,
    ERROR_ORDER_OPERATION: `Désolé, nous n'avons pas pu traiter votre commande. Veuillez réessayer.`,
    ERROR_PIN_LENGTH: `Le code PIN n'a pas la bonne longueur.`,
    ERROR_RECEIVING_PAYMENT: `Le terminal n'a pas pu traiter votre paiement. Veuillez réessayer.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `Aucun paiement reçu. Cette commande n'a pas été envoyée. Votre reçu contiendra un résumé de votre commande. Veuillez contacter un membre du personnel pour obtenir de l'aide.`,
    ERROR_SENDING_ORDER: `Bonjour, il semble y avoir un problème lors de l'envoi de votre commande en cuisine. Veuillez contacter un membre du personnel.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `Le paiement a réussi, mais il y a eu un problème lors de l'envoi de votre commande en cuisine. Veuillez contacter un membre du personnel. Votre reçu contiendra un résumé de votre commande.`,
    ERROR_STARTING_ORDER: `Désolé, nous n'avons pas pu démarrer votre commande. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    ERROR_UPDATING_ORDER: `Désolé, nous n'avons pas pu mettre à jour votre commande. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `Impossible d'afficher cet article. Vous avez atteint la limite d'alcool pour cette commande. Veuillez supprimer une boisson alcoolisée pour ajouter celle-ci.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `Impossible d'afficher cet article. Vous avez atteint la limite d'offre spéciale pour cette commande. Veuillez supprimer un article en offre spéciale pour ajouter celui-ci.`,
    EXIT: `Quitter`,
    EXIT_CONFIRMATION: `Êtes-vous sûr de vouloir quitter ? Quitter annulera votre commande.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Favori`,
    FAVORITES: `Favoris`,
    FAVORITES_NONE_YET: `Aucun favori pour l'instant.`,
    FAVORITES_REMOVE_CONFIRMATION: `Êtes-vous sûr de vouloir supprimer ce favori ?`,
    FETCHING_RECOMMENDATIONS: `Chargement des recommandations...`,
    FIND_ACCOUNT: `Rechercher un compte`,
    FIRST_NAME: `Prénom`,
    FORGOT_PASSWORD: `Mot de passe oublié ?`,
    FULFILLMENT_LABEL_ADDRESS: `Adresse`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `E-mail`,
    FULFILLMENT_LABEL_GUEST_NAME: `Pour`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Numéro de commande`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Numéro de table`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Numéro de téléphone`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Numéro de suivi`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Description du véhicule`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Votre commande sera livrée à l'adresse ci-dessous.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Nous vous enverrons le reçu.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Votre nom sera appelé quand votre commande sera prête.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Votre numéro de commande sera appelé.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Vous recevrez un SMS quand votre commande sera prête.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Votre commande sera servie à votre table.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Votre traceur sonnera quand la commande sera prête.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Votre commande vous sera apportée dès que vous serez arrivé devant le restaurant.`,
    FULFILLMENT_TOGGLE: `Basculer la méthode de livraison active`,
    FULL_NAME: `Nom complet`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `Désolé ! Impossible de trouver le menu pour ce créneau. Veuillez réessayer.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `Désolé ! Aucun créneau disponible. Veuillez essayer une autre option de restauration.`,
    FUTURE_ORDER_SET_FOR: `Commande prévue pour :`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `Désolé ! Le créneau choisi n'est plus disponible. Veuillez sélectionner un autre créneau.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Une erreur s'est produite lors du chargement des créneaux disponibles. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `Veuillez sélectionner un créneau.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Créneaux horaires`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Aujourd'hui`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Demain`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Retrait aujourd'hui à {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Retrait le prochain jour ouvrable à {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Délai de préparation estimé : {{$1: time}}`,
    GENERIC_ERROR: `Oups ! Une erreur s'est produite. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    GET_REWARDS: `Obtenir des récompenses`,
    GET_RECEIPT: `Obtenir un reçu`,
    GET_RECEIPT_DIALOG_TITLE: `Options de reçu`,
    GIFT_CARD: `Carte-cadeau`,
    GIFT_CARD_SECONDARY: `Carte-cadeau alternative`,
    GIFT_CARD_TITLE: `Payer maintenant`,
    GIFT_CARD_SUBTITLE: `Payez en glissant votre carte-cadeau sur le terminal de paiement.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Erreur de scan de carte-cadeau`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `Nous n'avons pas pu scanner votre carte-cadeau. Veuillez réessayer.`,
    GIFT_CARD_APPLYING_TITLE: `Application de la carte-cadeau`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Erreur d'application de la carte-cadeau`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `Nous n'avons pas pu appliquer votre carte-cadeau. Veuillez réessayer.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Solde insuffisant sur la carte-cadeau`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `Votre carte-cadeau n'a pas de solde.`,
    GIFT_CARD_ADD_ANOTHER: `Ajouter une autre`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Veuillez saisir un numéro de carte-cadeau.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `Veuillez saisir un numéro de carte-cadeau valide.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Veuillez saisir un numéro de carte-cadeau valide.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `Veuillez saisir un code PIN.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `Veuillez saisir un code PIN valide.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `Veuillez saisir un code PIN valide.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Saisissez le numéro de carte-cadeau. Les numéros peuvent comporter {{$1: length}} chiffres.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Saisissez le code PIN. Les numéros peuvent comporter {{$1: length}} chiffres.`,
    GIFT_CARD_ERROR_REMOVING: `Erreur lors de la suppression de la carte-cadeau. Veuillez réessayer. Si le problème persiste, contactez un membre du personnel.`,
    'gift-card.select-account.title': `Sélectionner un compte`,
    'gift-card.select-account.loading': `Chargement des comptes...`,
    'gift-card.select-account.error.title': `Impossible de charger les comptes`,
    'gift-card.select-account.error.message': `Nous n'avons pas pu charger vos comptes. Veuillez réessayer.`,
    'gift-card.select-account.column.account': `Compte`,
    'gift-card.select-account.column.balance': `Solde actuel`,
    'gift-card.select-account.error.toast-title': `Erreur`,
    'gift-card.select-account.error.toast-message': `Échec de la validation. Veuillez réessayer.`,
    GLOSSARY_TERM_LEARN_MORE: `En savoir plus`,
    GOES_WELL_WITH: `Se marie bien avec`,
    GRAND_TOTAL: `Total général`,
    GROUP_ORDERING_ADD_GUEST: `Ajouter un invité`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `Le nom de l'invité contient des caractères invalides.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `Ce nom d'invité est déjà utilisé. Veuillez en saisir un autre.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Invité {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Commande groupée - Pour qui est cet article ?`,
    GROUP_ORDERING_LABEL: `Commande groupée - Article pour :`,
    GROUP_ORDERING_TITLE: `Commande groupée`,
    GROUP_ORDERING_SUBTITLE: `L'option de commande groupée vous demandera à quel membre de votre groupe correspond chaque article. Appuyez sur « Oui » pour activer la commande groupée. Appuyez sur « Non » pour continuer.`,
    GUEST_INFO: `Infos client`,
    GUEST_RATING_LABEL_0: `Appuyer pour noter 0 : Très insatisfait`,
    GUEST_RATING_LABEL_1: `Appuyer pour noter 1 : Plutôt insatisfait`,
    GUEST_RATING_LABEL_2: `Appuyer pour noter 2 : Plutôt satisfait`,
    GUEST_RATING_LABEL_3: `Appuyer pour noter 3 : Très satisfait`,
    GUEST_RATING_0: `Merci de vos commentaires!`,
    GUEST_RATING_1: `Merci de vos commentaires!`,
    GUEST_RATING_2: `Merci de vos commentaires!`,
    GUEST_RATING_3: `Merci de vos commentaires!`,
    GUEST_RATING_SUBMITTED: `Merci de vos commentaires !`,
    HIDE: `Masquer`,
    HOME: `Accueil`,
    HOW_DID_WE_DO: `Comment avons-nous fait ? Notez-nous !`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `Comment souhaitez-vous payer ?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `Comment souhaitez-vous votre commande ?`,
    KITCHEN_CLOSED: `Désolé, la cuisine est fermée.`,
    ID_CHECK_LABEL: `Votre commande contient de l'alcool. Il peut vous être demandé de présenter une pièce d'identité.`,
    ID_CHECK_CODE_MESSAGE: `Un code d'accès employé est requis pour payer avec de l'alcool. Veuillez demander l'aide d'un membre de l'équipe.`,
    IE_WARNING: `Nous avons remarqué que vous accédez à notre site depuis Internet Explorer. Pour une expérience optimale, veuillez parcourir notre site avec des navigateurs pris en charge comme Google Chrome, Safari, Firefox ou Microsoft Edge.`,
    INCLUDE_UTENSILS: `Inclure les couverts`,
    ITEM_86D: `Bonjour, il semble y avoir un problème lors de l'envoi de votre commande en cuisine car un article est en rupture de stock. Veuillez contacter un membre du personnel.`,
    ITEM_86D_VALIDATION: `Bonjour, il semble y avoir un problème pour envoyer votre commande à la cuisine en raison d'un article en rupture de stock. Veuillez contacter un membre du personnel pour obtenir de l'aide.`,
    ITEM_RECIPIENT: `Préparé pour`,
    ITEM_RECIPIENT_FOR: `Préparé pour {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Recommandé`,
    ITEM_STEP_TITLE: `Étape {{$1: step}}`,
    ITEM_STEP_EMPTY: `Aucun choix effectué à cette étape`,
    ITEM_STEP_NO_RECOS: `Aucune recommandation disponible`,
    ITEMS_NO_LONGER_IN_MENU: `Certains articles ont été retirés de votre panier car ils ne sont plus au menu`,
    ITEM_SCAN_ERROR: `Nous n'avons pas trouvé cet article. Veuillez l'ajouter à partir du menu ou demander de l'aide à un membre du personnel.`,
    ITEM_SCAN_SUCCESS: `Article ajouté au panier !`,
    LAST_NAME: `Nom de famille`,
    LEAD_TIME_LONG: `Votre commande peut nécessiter plus de temps que le créneau actuellement sélectionné.`,
    LEAD_TIME_CART: `Cette commande peut prendre plus de temps à préparer que l'heure de retrait demandée en raison de certains articles sélectionnés.`,
    LANGUAGE_SELECT_LABEL: `Appuyer pour sélectionner la langue`,
    LOADING: `Chargement...`,
    LOADING_MENU: `Chargement du menu...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Rechercher des restaurants`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Trouver un restaurant pour {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `Comment souhaitez-vous commander ?`,
    LOCATION_SEARCH_HEADER: `Bienvenue chez {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Adresse, ville et état, ou code postal`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Se connecter`,
    LOGIN: `Se connecter`,
    LOGIN_GIFT_CARD: `Connexion carte-cadeau`,
    LOGIN_GIFT_CARD_SECONDARY: `Connexion carte-cadeau alternative`,
    LOGIN_WALL_WELCOME: `Bonjour !`,
    LOGIN_WALL_WELCOME_USER: `Bonjour, {{$1: user}} !`,
    LOGIN_WITH_CARD_NUMBER: `Se connecter avec le numéro de carte`,
    LOGIN_WITH_PHONE: `Se connecter avec le téléphone`,
    LOOKING_UP_ACCOUNT: `Recherche du compte...`,
    LOOKUP_CARD: `Recherche de la carte...`,
    LOOKUP_COUPON: `Recherche du coupon...`,
    LOYALTY: `Programme de fidélité`,
    LOYALTY_ACCOUNT_APPLY: `Appliquer`,
    LOYALTY_CARD_NUMBER: `Numéro de carte`,
    LOYALTY_EXIT_TO_MENU: `Aller au menu`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `Scanner le QR code de l'application`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `Pas d'application ? Saisissez votre numéro de téléphone.`,
    LOYALTY_AUTH_METHOD_BARCODE: `Scanner le QR code de l'application`,
    LOYALTY_AUTH_METHOD_HID: `Appuyer sur la carte HID`,
    LOYALTY_AUTH_METHOD_PHONE: `Saisissez votre numéro de téléphone.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Saisissez votre numéro de carte.`,
    LOYALTY_AUTH_METHOD_EMAIL: `Saisissez votre e-mail.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Saisissez votre e-mail et mot de passe.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Saisissez votre e-mail et numéro de téléphone.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Saisissez votre nom d'utilisateur et mot de passe.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Saisissez le numéro de téléphone de votre compte :`,
    LOYALTY_APP_AUTH_SUBTITLE: `Pour trouver le code-barres, ouvrez votre application sur l'écran PAYER.`,
    LOYALTY_APP_AUTH_TITLE: `Scannez le code-barres de paiement de votre application avec le scanner ci-dessous.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `Saisir manuellement le code de récompense à 7 chiffres`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `Saisissez un code de récompense à 7 chiffres :`,
    LOYALTY_APPLY_REWARD_FAILED: `Échec de l'application de la récompense. Veuillez réessayer.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `Échec de l'application des récompenses suivantes : {{$1: reward names}}. Veuillez réessayer.`,
    LOYALTY_APPLYING_REWARD: `Application de la récompense...`,
    LOYALTY_AUTH_GENERIC_ERROR: `Désolé ! Nous n'avons pas pu trouver ce compte de récompenses. Veuillez réessayer.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Connectez-vous pour gagner et utiliser vos points du programme de récompenses.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Récompenses disponibles`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Solde actuel`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Désolé, vous ne pouvez plus modifier vos récompenses une fois la commande payée.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Désolé, cette récompense ne peut plus être supprimée une fois appliquée à la commande.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Saisissez votre numéro de carte pour gagner et utiliser vos points du programme de récompenses.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Désolé, vous ne pouvez pas utiliser vos récompenses car un coupon est appliqué.`,
    LOYALTY_GETTING_REWARDS: `Chargement de vos récompenses...`,
    LOYALTY_FETCH_REWARDS_FAILED: `Échec du chargement des récompenses. Veuillez réessayer.`,
    LOYALTY_REWARD_APPLY: `Appliquer`,
    LOYALTY_REWARD_APPLY_FAILED: `Échec de l'application des récompenses. Certaines récompenses peuvent ne pas s'appliquer à votre commande.`,
    LOYALTY_REWARD_APPLIED: `Appliqué`,
    LOYALTY_REWARD_INVALID: `Invalide`,
    LOYALTY_REWARD_LABEL_MEAL: `Repas`,
    LOYALTY_REWARD_LABEL_MEALS: `Repas`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Échanger maintenant`,
    LOYALTY_REWARD_LABEL_SELECTED: `Sélectionné`,
    LOYALTY_REWARD_LABEL_APPLIED: `Échangé`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Échangé au paiement`,
    LOYALTY_REWARD_LABEL_REMOVING: `Suppression`,
    LOYALTY_REWARD_LABEL_ERROR: `Erreur d'application`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `Non applicable`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Récompenses`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Récompenses basées sur un pourcentage`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Récompenses fixes`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Récompenses portefeuille`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Récompenses portefeuille et paiement`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Récompenses article gratuit`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Récompenses échange de repas`,
    LOYALTY_REWARDS_FOR: `pour`,
    LOYALTY_NO_REWARDS_LABEL: `Aucune récompense`,
    LOYALTY_NO_REWARDS_NO_EARNING: `Aucune récompense applicable pour ces articles.`,
    LOYALTY_NO_REWARDS_TEXT: `Aucune récompense applicable pour ces articles, mais vous gagnerez quand même des points avec cette commande !`,
    LOYALTY_PAYMENT: `Avec fidélité`,
    LOYALTY_PAYMENT_CARD_CHARGED: `{{$1: charge_amount}} sera débité de la carte enregistrée.`,
    LOYALTY_PAYMENT_FAILED: `Échec de l'application du paiement.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Un problème s'est produit lors du traitement du paiement de fidélité. Veuillez réessayer ou choisir un autre mode de paiement.`,
    USE_LOYALTY_PAYMENT: `Utiliser la fidélité`,
    LOYALTY_PAYMENT_SUBMIT: `Effectuer le paiement`,
    LOYALTY_PAYMENT_REWARD: `Débité sur la fidélité`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `Votre carte enregistrée chez le fournisseur sera débitée pour cette transaction.`,
    LOYALTY_PAY_WITH_APP: `Payer avec l'application`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Points de récompense estimés pour cette commande :`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }} points`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Statut du compte`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `Nous n'avons pas trouvé votre compte.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Veuillez vous connecter à votre compte ci-dessous pour gagner des points et échanger des récompenses.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `S'inscrire avec un numéro de téléphone`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `Vous pouvez encore gagner des points sur votre commande aujourd'hui en scannant le reçu après votre inscription !`,
    LOYALTY_INTRO_QR_SIGN_IN: `Veuillez scanner votre QR code ci-dessous pour vous connecter.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Veuillez scanner le QR code ci-dessous pour vous inscrire.`,
    LOYALTY_INTRO_WELCOME_BACK: `Bienvenue,`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `Le numéro de téléphone fourni est associé à plus d'un compte de fidélité ou n'existe pas.`,
    LOYALTY_REDEMPTION_CODE: `Appliquer un code d'échange`,
    LOYALTY_REMOVING_REWARD: `Suppression de la récompense...`,
    LOYALTY_SCAN_FAILED_TITLE: `Échec du scan`,
    LOYALTY_SCAN_FAILED_MESSAGE: `Nous n'avons pas pu scanner votre QR code. Veuillez réessayer.`,
    LOYALTY_SIGN_OUT_NOTICE: `Vous serez automatiquement déconnecté lorsque votre commande sera passée ou que vous quitterez le menu.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `Vous serez automatiquement déconnecté lorsque votre commande sera passée ou que vous quitterez le menu. Les mots de passe ne sont jamais enregistrés.`,
    LOYALTY_SIGN_UP_SMS_SENT: `Message d'inscription envoyé !`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Retour à la connexion`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `Inscription réussie !`,
    LOYALTY_SIGN_UP_WITH_QR: `S'inscrire avec un QR code`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `S'inscrire avec un numéro de téléphone`,
    LOYALTY_WELCOME_TITLE: `Gagnez et utilisez des récompenses`,
    LOYALTY_SIGNUP_TITLE: `Recevez un lien d'inscription sur votre téléphone`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Vous avez actuellement`,
    LOYALTY_NAV_REWARDS: `Mes récompenses`,
    LOYALTY_NAV_ORDER_HISTORY: `Mes commandes`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Vous avez dépassé le nombre maximum de tentatives de connexion.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Vous avez dépassé le nombre maximum de tentatives d'accès à la carte-cadeau.`,
    MAKE_IT_A_COMBO: `En faire un menu ?`,
    MAKE_IT_A_COMBO_MOD: `Vous voulez en faire un combo?`,
    MAKE_IT_A_COMBO_ACCEPT: `Oui, s'il vous plaît !`,
    MAKE_IT_A_COMBO_REJECT: `Non, merci !`,
    MAKE_IT_A_COMBO_NO: `Non merci, sans menu.`,
    MAKE_IT_A_COMBO_YES: `En faire un menu ?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `Excellent choix !`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `Choisissez votre accompagnement et boisson ci-dessous !`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `Ajoutez un accompagnement et une boisson pour en faire un menu !`,
    MENU_COVER_ALT_TEXT: `Appuyez ici pour commencer à commander`,
    MENU_COVER_LOYALTY_TEXT: `Connectez-vous à la fidélité pour gagner des points et échanger des récompenses`,
    MENU_COVER_QUIZ_TEXT: `Faites le quiz pour découvrir quel article est fait pour vous !`,
    MENU_COVER_WAYFINDER_TEXT: `Accédez à notre guide d'orientation pour vous repérer`,
    MAINTENANCE_COVER_TITLE: `Ce kiosque est en maintenance`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le HID est connecté au kiosque.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID déconnecté`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le KDS est connecté au kiosque.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS déconnecté`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Veuillez essayer un autre kiosque ou demander l'aide d'un membre du personnel.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Ce kiosque est actuellement indisponible`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le lecteur de bande magnétique est connecté au kiosque.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Lecteur de bande magnétique déconnecté`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le kiosque est connecté au réseau.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Pas de connexion réseau`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Ce kiosque a des difficultés de connexion en raison d'une vitesse internet faible. Veuillez vérifier que votre connexion est stable. Vitesse recommandée : minimum 10 Mbps en upload et download.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Réseau instable détecté`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le terminal de paiement est allumé et connecté au kiosque.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Terminal de paiement déconnecté`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Veuillez vous assurer que le couvercle de l'imprimante est fermé.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Couvercle d'imprimante ouvert`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Veuillez vous assurer que l'imprimante est connectée au kiosque.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Imprimante déconnectée`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Veuillez vous assurer que l'imprimante a du papier.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Imprimante sans papier`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Veuillez vous assurer que la balance est connectée au kiosque.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Balance déconnectée`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Veuillez vous assurer que le scanner est connecté au kiosque.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Scanner déconnecté`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `La limite maximale de boissons alcoolisées par commande est {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `La limite maximale d'articles spéciaux par commande est {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `Comment souhaitez-vous commander ?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Sélectionnez une langue pour commencer`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Appuyez ici pour commencer la commande et voir cet article promu : {{$1: item name}} !`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Appuyez ici pour commencer la commande et aller directement à cette section promue : {{$1: section name}} !`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Appuyez ici pour commencer la commande et aller directement à cette page promue : {{$1: page name}} !`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `Appuyez ici pour démarrer la commande pour « {{$1: fulfillment method}} » !`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Retour aux options de restauration`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Retour au numéro de téléphone`,
    MARKETING_CONSENT: `Je souhaite recevoir des actualités, mises à jour, réductions et offres`,
    MENU_FILTERS_DIETARY_FILTERS: `Régime`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Pour une option plus saine, sélectionnez l'une de ces options pour n'afficher que celles-ci sur le menu`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Préférences nutritionnelles`,
    MENU_FILTERS_OTHER_FILTERS: `Autres`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Restrictif`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Si vous avez certaines intolérances, sélectionnez l'une d'entre elles pour les masquer dans le menu`,
    MENU_FILTERS_COUNT: `{{$1: number}} préférences nutritionnelles actives. Appuyer pour modifier.`,
    MOD_86D: `Bonjour, il semble y avoir un problème pour envoyer votre commande à la cuisine en raison d'un article en rupture de stock. Veuillez contacter un membre du personnel pour obtenir de l'aide. Notez que votre paiement A ÉTÉ accepté par le restaurant.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} articles au total`,
    MOD_GROUP_CHOICES_INCREMENT: `multiples de {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `faites un choix unique`,
    MOD_GROUP_CHOICES_MAKE_X: `faites {{$1: number range, e.g. 2-3}} choix`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} par choix`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Choisir au moins {{$1: number}}`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Choisir entre {{$1: number}} et {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `Choisir un`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Choisir jusqu'à un`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Choisir jusqu'à {{$1: number}}`,
    MOD_GROUP_CHOOSE_X: `Choisir {{$1: number}}`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Afficher - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Masquer - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `{{$1: dollar amount}} à dépenser avant d'être facturé.`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `Choix supplémentaires à {{$1: dollar amount}} par choix.`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `Les {{$1: number}} premiers sont gratuits.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `Le premier est gratuit.`,
    MOD_GROUP_WALLET_UP_TO_X: `Jusqu'à {{$1: number}} à {{$2: dollar amount}} par choix`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Fermer la substitution`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Modifier la substitution`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Substituer`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Ajouter à l'article`,
    MOD_RECOMMENDED_BADGE: `Recommandé`,
    MOD_UPSELL_PROMPT_TITLE: `Ajouter une option ?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Ajouter`,
    MOD_UPSELL_PROMPT_DECLINE: `Non, merci`,
    MODIFY: `Modifier`,
    MODIFY_INGREDIENTS: `Modifier les ingrédients`,
    MORE: `plus`,
    NAME_CALLED_ORDER_READY: `Votre nom sera appelé quand votre commande sera prête.`,
    NAME_ON_CARD: `Nom sur la carte`,
    NEED_MORE_TIME: `Besoin de plus de temps ?`,
    NEW_PASSWORD: `Nouveau mot de passe`,
    NEXT: `Suivant`,
    NO: `Non`,
    NO_ITEMS_MATCH_FILTERS: `Aucun article ne correspond à vos filtres.`,
    NO_ORDERS_MATCH: `Aucune commande ne correspond à votre recherche.`,
    NO_THANKS: `Non, merci`,
    NO_TIP: `Sans pourboire`,
    NOT_A_MEMBER: `Pas encore membre ?`,
    NUTRITION_INFO_CALORIES: `Calories`,
    NUTRITION_INFO_PROTEIN: `Protéines`,
    NUTRITION_INFO_FAT: `Graisses`,
    NUTRITION_INFO_CARBS: `Glucides`,
    NUTRITION_INFO_SUGAR: `Sucres`,
    OK: `OK`,
    OR: `ou`,
    OPT_OUT_OF_RECOMMENDATIONS: `Refuser les recommandations`,
    ORDER_GET_ERROR: `Désolé, nous avons eu du mal à créer votre commande. Veuillez réessayer.`,
    ORDER_HISTORY: `Historique des commandes`,
    ORDER_HISTORY_EMPTY: `Aucune commande dans votre historique. Une fois que vous aurez passé une commande, elle apparaîtra ici.`,
    ORDER_HISTORY_ERROR: `Désolé, nous avons eu du mal à charger votre historique de commandes. Veuillez réessayer.`,
    ORDER_SENT: `Commande envoyée`,
    ORDER_SUMMARY: `Récapitulatif de la commande`,
    ORDER_SUMMARY_WITH_NAME: `Récapitulatif de la commande pour {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Récapitulatif de la commande. Commande {{$1 fulfillment}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour la table {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour le traceur #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}} à la table {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}} pour le traceur #{{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour la commande #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour le traceur #{{$2: tracker number}} pour la commande #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour la table {{$2: table number}} pour la commande #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}} pour la commande #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}} à la table {{$3: table number}} pour la commande #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Récapitulatif de la commande. Commande {{$1 fulfillment}} pour {{$2 guest name}} au traceur {{$3: tracker number}} pour la commande #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `Désolé ! Le restaurant reçoit plus de commandes qu'il ne peut en traiter. Veuillez essayer avec un autre créneau horaire.`,
    ORDER_TIME_ASAP: `Passer une commande dès que possible`,
    ORDER_TIME_LATER: `Plus tard aujourd'hui`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Prochain jour ouvrable`,
    ORDER_TIME_FUTURE: `Commander pour plus tard`,
    ORDER_TOTAL_MAX_EXCEEDED: `Pour les grandes commandes, veuillez vous adresser à un membre du personnel.`,
    ORDER_UPDATE_FAILED: `Échec de la mise à jour de la commande.`,
    ORDER_VALIDATION_IN_PROGRESS: `Validation de votre commande`,
    ORDER_VALIDATION_FAILED: `Oups ! Une erreur s'est produite.`,
    ORDER_WAS_PLACED: `Votre commande a été passée.`,
    ORDERING_MODE_CHANGED: `Mode de commande modifié. Votre session a été réinitialisée.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Appuyez ici pour transformer {{$1: ordered item name}} en menu.`,
    ORDERED_ITEM_COMBO_LABEL: `Combo`,
    ORDERING_ITEM_ABSENCE_RESET: `Cet article était obsolète. L'article a été réinitialisé à son état initial. Veuillez réessayer.`,
    OUR_MENU: `Notre menu`,
    OUTPOST_PICKUP: `Retrait au point relais`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Saisissez votre numéro de chambre du point relais`,
    OUTPOST_ROOM_NUMBER_TITLE: `Numéro de chambre`,
    OUT_OF_STOCK: `Rupture de stock`,
    PAGE_NAVIGATION_TITLE: `Appuyez sur l'une des options ci-dessous pour accéder à une page spécifique du menu. {{$1: total}} pages disponibles.`,
    PARTIAL_PAYMENT_LINE: `Paiement partiel`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Paiement partiel`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `Il y a un paiement partiel sur cette commande. Si vous souhaitez revenir en arrière, votre paiement sera d'abord remboursé.`,
    PASSWORD: `Mot de passe`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `Bonjour, si vous ne finalisez pas le paiement dans les 5 prochaines minutes, nous annulerons la commande et rembourserons votre paiement.`,
    PAY_AT_CASHIER: `Veuillez vous diriger vers la caisse pour payer.`,
    PAY_NOW: `Payer maintenant`,
    PAY_WITH: `Payer avec`,
    PAY_WITH_CREDIT: `Payer par carte de crédit`,
    PAY_WITH_DEBIT_CREDIT: `Payer par débit/crédit`,
    PAYMENT: `Paiement`,
    PAYMENT_DETAILS: `Détails du paiement`,
    PAYMENT_LINE_LABEL_DONATION: `Don de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `Le sous-total est {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Paiement partiel de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Utilisation de la carte-cadeau de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Réduction coupon de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Réduction coupon de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `Paiement EBT de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Échange de fidélité de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Échange de récompense de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Réduction de {{$1: name}} pour {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `La taxe est {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `Le pourboire est {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `Frais de service de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `Frais de service de {{$1: amount}} pour {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `Le total général est {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `Le solde restant est {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `Le montant payé est {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Appuyer pour payer en espèces`,
    PAYMENT_OPTION_LABEL_CARD: `Appuyer pour payer par carte de crédit`,
    PAYMENT_OPTION_LABEL_COUPON: `Appuyer pour utiliser un coupon`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Appuyer pour utiliser une carte de courtoisie`,
    PAYMENT_OPTION_LABEL_DONATION: `Appuyer pour faire ou modifier des dons`,
    PAYMENT_OPTION_LABEL_EBT: `Appuyer pour payer avec EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Appuyer pour rembourser EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Appuyer pour payer avec la prestation en espèces EBT`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Appuyer pour payer avec les bons alimentaires EBT`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Appuyer pour payer avec une carte-cadeau`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Appuyer pour utiliser des récompenses`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Appuyer pour utiliser des récompenses`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Appuyer pour finaliser le paiement`,
    PAYMENT_PROMPT_NFC: `Payez avec le terminal en insérant votre carte ou en approchant votre téléphone.`,
    PAYMENT_PROMPT_DIP: `Payez avec le terminal en insérant votre carte.`,
    PAYMENT_SUCCESSFUL: `Paiement réussi`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Désolé, votre paiement a échoué. Veuillez réessayer.`,
    PAYMENT_KIOSK_TIMEOUT: `Désolé, la session de paiement a expiré. Veuillez réessayer.`,
    PAYMENT_TOTAL: `Total du paiement`,
    PAYMENT_WAS_TAKEN: `Veuillez noter que votre paiement a été traité.`,
    PAYMENT_WAS_NOT_TAKEN: `Veuillez noter que votre paiement n'a pas été traité. Ceci n'est pas une confirmation de paiement.`,
    PHONE_NUMBER: `Numéro de téléphone`,
    PICK_UP: `Retrait`,
    PICK_UP_AT: `Retrait à`,
    PICK_UP_ENTER_NUMBER: `Veuillez prendre un numéro et le saisir ci-dessous :`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Bonjour {{$1: guest name}}, veuillez prendre un numéro et le saisir ci-dessous :`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Veuillez prendre un traceur et saisir son numéro :`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Bonjour {{$1: guest name}}, veuillez prendre un traceur et saisir son numéro :`,
    PLACE_ORDER: `Passer la commande`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Veuillez saisir un montant valide à rembourser.`,
    PLEASE_USE_TEST_CARD: `Cet établissement est encore en mode test. Veuillez utiliser une carte de test pour payer.`,
    PLEASE_WAIT: `Veuillez patienter...`,
    PRICE: `Le prix est {{$1:price}}`,
    PRINTING_RECEIPT: `Impression de votre reçu...`,
    PRINT_RECEIPT: `Imprimer le reçu`,
    PRINT_RECEIPT_ERROR: `Désolé, une erreur s'est produite lors de l'impression de votre reçu. Veuillez réessayer plus tard.`,
    PRINTED_RECEIPT_COMMAND: `N'oubliez pas de prendre votre reçu !`,
    PROCESSING_PAYMENT: `Traitement du paiement...`,
    PROMOTED_MODIFIER: `Promu!`,
    QUANTITY_SELECT: `{{$1:quantity}} sélectionné`,
    QUANTITY_SELECT_INCREASE: `Augmenter la quantité`,
    QUANTITY_SELECT_DECREASE: `Diminuer la quantité`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `Quitter`,
    QUICK_CHECKOUT: `Paiement rapide`,
    QUICK_NAV_TAP_TO_VIEW: `Appuyer pour voir :`,
    QUIZ_RESULTS_TITLE: `Résultats`,
    QUIZ_RESULTS_EMPTY: `Aucun résultat trouvé. Réessayez avec un autre ensemble de réponses.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Appuyer pour voir le résultat suivant. {{$1:index}} sur {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Appuyer pour voir le résultat précédent. {{$1:index}} sur {{$2:total}}`,
    QUIZ_STEP_ERROR: `Veuillez répondre à toutes les questions avant de continuer.`,
    QUIZ_STEP_ANSWER_LABEL: `Appuyer pour répondre avec {{$1:badge name}} :`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Scannez le QR code pour obtenir une copie de votre reçu sur votre téléphone.`,
    RECEIPT_AUTHORIZATION: `Autorisation`,
    RECEIPT_CARD_NUMBER: `Carte n°`,
    RECEIPT_CHECK_ID: `VÉRIFICATION DE L'IDENTITÉ`,
    RECEIPT_DISCOUNTS: `Réductions`,
    RECEIPT_DONATION: `Don`,
    RECEIPT_FAILED: `Bonjour, il semble y avoir un problème lors de l'envoi de votre commande en cuisine. Veuillez contacter un membre du personnel.`,
    RECEIPT_FAILED_ITEM_86D: `Bonjour, il semble y avoir un problème pour envoyer votre commande à la cuisine en raison d'un article en rupture de stock. Veuillez contacter un membre du personnel pour obtenir de l'aide.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `Les articles suivants n'ont pas été inclus dans le code QR car ils n'ont pas de code de prix unitaire associé:`,
    RECEIPT_NOT_RECEIPT: `Ceci n'est pas un reçu ni une preuve d'achat.`,
    RECEIPT_ORDER: `COMMANDE`,
    RECEIPT_ORDER_TOTAL: `Total de la commande`,
    RECEIPT_PAY_AT_CASHIER: `VEUILLEZ PAYER À LA CAISSE`,
    RECEIPT_PICK_UP_AT_LABEL: `Retrait à`,
    RECEIPT_PICKUP_TIME_LABEL: `Heure de retrait`,
    RECEIPT_DELIVERY_TIME_LABEL: `Heure de livraison`,
    RECEIPT_PRINTED: `Reçu imprimé`,
    RECEIPT_REFUNDED: `Remboursé`,
    RECEIPT_REMAINING_BALANCE: `Solde restant`,
    RECEIPT_SELF_SERVE: `Libre-service:`,
    RECEIPT_SPECIAL_REQUEST: `Demand spéciale`,
    RECEIPT_SUB_TOTAL: `Sous-total`,
    RECEIPT_TAX_TOTAL: `Total des taxes`,
    RECEIPT_TIP_THANKS: `Pourboire (Merci !)`,
    RECEIPT_SERVICE_CHARGE: `Frais de service`,
    RECEIPT_TRANS_NO: `NUM TRANSAC KIOSQUE`,
    RECEIPT_YOUR_CHECK_NUMBER: `Votre numéro de ticket est`,
    RECOMMENDATIONS: `Recommandations`,
    RECOMMENDED_FOR_YOU: `Recommandé pour vous`,
    REFUND: `Remboursement`,
    REFUNDER_ALREADY_REFUNDED: `Remboursé`,
    REFUNDER_DELAY_MESSAGE: `Les remboursements peuvent prendre quelques jours pour apparaître sur votre relevé de compte.`,
    REFUNDER_INSTRUCTIONS: `Recherchez des commandes en utilisant le numéro d'autorisation figurant sur la facture, le numéro de commande, l'adresse courriel, le numéro de téléphone, les quatre derniers chiffres de la carte, le numéro de référence de la transaction ou l'ID de la commande.`,
    REFUNDER_SEARCH_PLACEHOLDER: `Numéro d'autorisation du reçu, numéro de commande ou quatre derniers nuléros de la carte`,
    REFUNDER_TITLE: `Rembourser une commande`,
    REFUNDER_SEARCHING_TITLE: `Recherche en cours`,
    REFUNDER_RESULTS_TITLE: `Commandes`,
    REFUNDER_RESULTS_EMPTY: `Aucune commande trouvée. Veuillez vérifier vos critères de recherche et réessayer.`,
    REFUNDER_REFUNDING_TITLE: `Remboursement en cours`,
    REFUNDER_REFUND_ERROR: `Une erreur s'est produite lors du traitement de votre remboursement. Veuillez réessayer. Si le problème persiste, contactez le support.`,
    REFUNDER_REFUND_SUCCESS: `Remboursement réussi ! La transaction sera traitée sous peu.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Rechercher à nouveau`,
    REFUNDER_SEARCH_INPUT_ERROR: `Veuillez saisir un numéro d'autorisation, un numéro de commande ou les quatre derniers chiffres de la carte valides.`,
    REFUNDER_SEARCH_ERROR: `Une erreur s'est produite lors de la recherche de votre commande. Veuillez réessayer. Si le problème persiste, contactez le support.`,
    REFUNDING: `Traitement du remboursement...`,
    REFUND_FAILED: `Le remboursement a échoué. Veuillez réessayer plus tard.`,
    REMOVE: `Supprimer`,
    REMOVE_CARD: `N'oubliez pas de retirer votre carte.`,
    REMOVE_COMP_CARD: `Supprimer la carte de courtoisie`,
    REMOVE_COUPON: `Supprimer le coupon`,
    REMOVE_GIFT_CARD: `Supprimer`,
    REMOVE_TIP: `Supprimer le pourboire`,
    REMOVING_COUPON: `Suppression du coupon...`,
    REPEAT_PASSWORD: `Répéter le mot de passe`,
    RESET: `Réinitialiser`,
    REWARDS: `Récompenses`,
    REWARDS_LOGGED_IN: `Récompenses`,
    REWARDS_APPLICABLE_TO_ORDER: `Applicable maintenant à votre commande`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Pas encore applicable à votre commande`,
    REWARDS_EDIT: `Modifier les récompenses`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} points`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} repas`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} points`,
    SAVE: `Mettre à jour`,
    SAVE_CARD: `Enregistrer la carte sur le compte pour les achats futurs.`,
    SCAN_COUPON_BELOW: `Vous pouvez scanner des coupons avec le scanner ci-dessous.`,
    SCAN_YOUR_GIFT_CARD: `Scannez votre carte-cadeau`,
    SEARCH: `Rechercher`,
    SEARCH_BEGIN: `Saisissez votre terme de recherche ci-dessous pour commencer.`,
    SEARCH_EMPTY: `Aucun résultat trouvé. Essayez un autre terme de recherche.`,
    SEARCH_HINT: `Recherchez des articles en utilisant n'importe quelle combinaison de nom ou de description.`,
    SECRET_MENU_IMAGE_ALT: `Appuyer pour voir le menu secret`,
    SELECT_DATE: `Sélectionner une date`,
    SELF_SERVE: `Libre-service`,
    SEND: `Envoyer`,
    SEND_LOYALTY_SMS: `Envoyer un SMS`,
    SEND_ORDER_UI_TIMEOUT: `Bonjour, nous essayons toujours d'envoyer votre commande à la cuisine. Veuillez contacter un membre du personnel pour obtenir de l'aide.`,
    SENT_LOYALTY_SIGNUP_SMS: `Le SMS a été envoyé! Consultez votre téléphone et connectez-vous à votre convenance.`,
    SENDING_ORDER_KITCHEN: `Envoi de la commande en cuisine...`,
    SENDING_ORDER_VALIDATION: `Confirmation de la commande...`,
    SENDING_RECEIPT: `Envoi du reçu...`,
    SENDING_SMS: `Envoi d'un SMS...`,
    SERVICE_CHARGE: `Frais de service`,
    SHOW: `Afficher`,
    SHOW_NUTRITION: `Afficher les informations nutritionnelles`,
    SHOW_STAFF_FIRST: `Veuillez montrer ce message à un membre du personnel avant de sortir.\nVraiment sortir?`,
    SIGNUP_CTA: `Inscrivez-vous pour un compte!`,
    SIGN_OUT: `Se déconnecter`,
    SIGN_UP: `S'inscrire`,
    SIGNUP_BENEFITS: `Créez un compte pour enregistrer votre carte de crédit et vos articles favoris pour un paiement plus rapide.`,
    SIGNUP_LOYALTY: `S'inscrire au programme de fidélité`,
    SKIP: `Ignorer`,
    SPECIAL_REQUESTS: `Demandes spéciales`,
    SPECIAL_REQUESTS_EXAMPLE: `ex : sauce à part, sans anchois, etc.`,
    SPECIAL_REQUESTS_FINEPRINT: `Les substitutions et demandes peuvent entraîner des frais supplémentaires.`,
    SPECIAL_REQUESTS_ADD: `Ajouter une demande spéciale`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `La demande spéciale est trop longue.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Veuillez utiliser uniquement des lettres, des chiffres et de la ponctuation.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Veuillez saisir une demande spéciale.`,
    SR_REMOVE_ITEM_FROM_CART: `Retirer l'objet du panier.`,
    STARTING_ORDER: `Démarrage de la commande...`,
    UPDATING_ORDER: `Mise à jour de la commande...`,
    START_ORDER_BY_SCANNING: `Commencez votre commande en scannant un article au bas du kiosque.`,
    START_NEW_ORDER: `Passer une autre commande`,
    STORED_VALUE_REMAINING_BALANCE: `restant`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Informations sur le restaurant`,
    STUDENT_CARD: `Carte étudiant`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Désolé, cette carte étudiant n'a plus de fonds.`,
    STUDENT_CARD_SUBTITLE_HID: `Appuyez votre carte étudiant pour payer`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Appuyez ou glissez votre carte étudiant pour payer`,
    STUDENT_CARD_SUBTITLE_MSR: `Glissez votre carte étudiant pour payer`,
    SUBMIT: `Soumettre`,
    SUBTOTAL: `Sous-total`,
    SUBTOTAL_REDUCED: `Sous-total réduit`,
    SUBTOTAL_INCREASED: `Nouveau sous-total`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `Vous économisez avec un menu !`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Vous économisez`,
    SUCCESS: `Succès`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Changer d'établissement`,
    SWITCH_TO_CATERING: `Passer à la restauration`,
    SWITCH_TO_WEB: `Passer à la commande en ligne`,
    SWIPE_YOUR_GIFT_CARD: `Glissez votre carte-cadeau pour payer`,
    SWIPE_YOUR_COMP_CARD: `Glissez votre carte de courtoisie pour payer`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Glissez ou scannez votre carte-cadeau pour payer`,
    TAKING_LONGER_THAN_USUAL: `Plus long que d'habitude...`,
    TAP_HERE_FOR_LANGUAGE: `Appuyez ici pour {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Appuyez en dehors pour fermer`,
    TAP_TO_REDEEM: `Appuyer pour échanger`,
    TAXES: `Taxe`,
    TERMS_OF_SERVICE: `Conditions d'utilisation`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Erreur lors du chargement des conditions d'utilisation`,
    TEXT_RECEIPT: `Reçu par SMS`,
    TEXT_RECEIPT_SEND_FAILED: `Impossible d'envoyer le reçu par SMS.`,
    TEXT_RECEIPT_SEND_SUCCESS: `Reçu envoyé !`,
    TEXT_YOU_WHEN_READY: `Nous vous enverrons un SMS quand votre commande sera prête.`,
    THANK_YOU: `Merci !`,
    THEN_PRESS_BUTTON_1: `Puis appuyez sur le`,
    THEN_PRESS_BUTTON_2: `bouton.`,
    TIP: `Pourboire`,
    TIPPING: `Traitement du pourboire...`,
    TIP_AMOUNT_TOO_HIGH: `Le montant du pourboire est trop élevé.`,
    TIP_AMOUNT_TOO_LOW: `Le montant du pourboire est trop faible.`,
    TIP_FAILED: `Désolé ! Impossible d'ajouter un pourboire. Veuillez réessayer.`,
    TIP_CANNOT_BE_MODIFIED: `Désolé ! Vous ne pouvez plus modifier votre pourboire une fois la commande payée.`,
    TIP_LABEL_PERCENT: `Appuyer pour ajouter un pourboire de {{$1: percent}}% ({{$2: amount}})`,
    TIP_LABEL_FIXED: `Appuyer pour ajouter un pourboire de {{$1: amount}}`,
    TIP_LABEL_CUSTOM: `Appuyer pour ajouter un pourboire personnalisé`,
    TIP_LABEL_NONE: `Appuyer pour supprimer le pourboire`,
    TO_GO: `À emporter`,
    TOTAL: `Total`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `Les prix de certains articles de votre commande ont changé.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `Le total partiel a changé et est maintenant`,
    TOTAL_CHANGED_LEADING_TEXT: `Le total a changé et est maintenant`,
    TOTAL_CHANGED_TRAILING_TEXT: `. Voulez-vous poursuivre la commande?`,
    TOTAL_PAID: `Total payé`,
    TOTAL_REMAINING: `Reste à payer`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Réessayer`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Nous n'avons pas pu trouver votre emplacement. Veuillez saisir votre adresse.`,
    UNAVAILABLE_ITEM: `Désolé, cet article n'est plus disponible.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} Calories`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} Protéines`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} Glucides`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} Graisses`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} Sucres`,
    UP_TO_X: `jusqu'à {{$1: number}}`,
    USE_COMP_CARD: `Utiliser la carte de courtoisie`,
    USE_COUPON: `Utiliser un coupon`,
    USE_EBT_CARD: `Carte EBT`,
    USE_EBT_CASH_BENEFIT: `Prestation en espèces EBT`,
    USE_EBT_FOOD_STAMP: `Bons alimentaires EBT`,
    USE_GIFT_CARD: `Utiliser une carte-cadeau`,
    USERNAME: `Nom d'utilisateur`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `Adresse courriel non valide`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} est requis`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Ce champ est requis`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Utiliser seulement des lettres et des chiffres`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Utiliser seulement des lettres, des chiffres, &, # ou .`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `Le mot de passe doit contenir au moins 1 chiffre, 1 lettre majuscule, 1 lettre minuscule et au moins 14 caractères.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `Numéro de téléphone non valide`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `Le code postal doit être numérique`,
    VENDOR_UNAVAILABLE_MESSAGE: `Ce prestataire est actuellement fermé. Veuillez vérifier ses horaires de travail et revenir plus tard.`,
    VEHICLE_COLOR: `Couleur du véhicule`,
    VEHICLE_MAKE: `Marque du véhicule`,
    VEHICLE_MODEL: `Modèle du véhicule`,
    VERIFY_ACCOUNT: `Vérifier le compte`,
    VERIFY_ACCOUNT_CTA: `Vérifiez votre compte pour commencer à passer des commandes.`,
    VIDEO_LOAD_FAILED: `Échec du chargement de la vidéo`,
    VIEW: `Voir`,
    WE_APOLOGIZE: `Nous nous excusons pour la gêne occasionnée.`,
    WEIGHING_INSTRUCTIONS: `Placez votre article sur la balance`,
    WELCOME_BACK: `Bienvenue ! Articles sélectionnés pour vous :`,
    WELCOME_BACK_WITH_NAME: `Bienvenue, {{$1: guest name}} ! Articles sélectionnés pour vous :`,
    WELCOME_TO: `Bienvenue chez {{$1: org name}} !`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Choisir l'heure de la commande`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `Où souhaitez-vous recevoir votre commande ?`,
    YES: `Oui`,
    YOU_PREVIOUSLY_ORDERED: `Vous avez précédemment commandé`,
    YOUR_CURRENT_LOCATION: `Votre emplacement actuel`,
    YOUR_NAME: `Votre nom`,
    YOUR_ORDER: `Votre commande`,
    YOUR_SUBTOTAL: `Votre sous-total`,
    ZOOM_TOGGLE_ON: `Appuyer pour activer le zoom par pincement`,
    ZOOM_TOGGLE_OFF: `Appuyer pour désactiver le zoom par pincement`,
    ZOOM_INSTRUCTIONS: `Le zoom par pincement est activé. Utilisez deux doigts pour zoomer et dézoomer.`,
    STARBUCKS_COVER_1_BUTTON: `Je sais ce que je veux`,
    STARBUCKS_COVER_2_BUTTON: `Faites-moi visiter`,
    STARBUCKS_COVER_2_TITLE: `Expériences, dégustations, apprentissage`,
    STARBUCKS_COVER_PROMO_A: `Trouver mon café`,
    STARBUCKS_COVER_PROMO_B: `Récompenses Starbucks`,
    STARBUCKS_EXPERIENCES_TITLE: `Expériences`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `Plongez dans l'art, le spectacle et l'innovation du café en réservant une expérience Signature`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `Réserver pour aujourd'hui`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `Réserver pour plus tard`,
    STARBUCKS_EXPERIENCES_BACK: `Retour aux expériences`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `En savoir plus`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `Aller au menu`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `Où suis-je ?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Vous êtes ici`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `Toilettes`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `Places libres`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Trouver un lieu`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Faites glisser avec votre doigt pour explorer l'espace.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Appuyez sur un lieu en surbrillance pour en savoir plus.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `Esprit d'aventure`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `À quel point aimez-vous un café aventureux ?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `Saveurs préférées`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `Quand vous pensez à votre café, quelles saveurs vous semblent les plus délicieuses ?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `Intensité`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `À quel point aimez-vous un café intense ?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `Commande de café préférée`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `Comment aimez-vous habituellement commander votre café ?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `Appuyer pour modifier`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `Confirmez votre sélection`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `Recommencer`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `Il semble que vous apprécieriez le`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `Achetez uniquement les grains, ou nous vous recommandons la boisson ci-dessous avec ce grain :`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `Voir le menu complet`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `Recommencer`,
    STARBUCKS_VIEW_WAYFINDER: `Faites-moi visiter`,
    STARBUCKS_VIEW_COFFEE_FINDER: `Affiner mes options`,
    STARBUCKS_VIEW_EXPERIENCES: `Voir les expériences`,
    'cover.session.timeout': `Une erreur s'est produite. Veuillez réessayer.`,
    'cover.reduced-height.button': `Commencer à commander`,
    'cover.loyalty.title': `Bienvenue`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Se connecter avec la fidélité`,
    'cover.loyalty.guest': `Continuer en tant qu'invité`,
    'guest-identifier.button.quit': `Quitter`,
    'guest-identifier.button.skip': `Ignorer`,
    'guest-identifier.button.back': `Retour`,
    'guest-identifier.button.next': `Continuer`,
    'guest-identifier.button.submit.cover': `Continuer`,
    'guest-identifier.button.submit.edit': `Continuer`,
    'guest-identifier.button.submit.checkout': `Continuer`,
    'guest-identifier.phone.tos.button-back': `Retour`,
    'guest-identifier.phone.tos.title': `Conditions d'utilisation`,
    'guest-identifier.phone.tos.link': `Conditions d'utilisation du numéro de téléphone`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Connectez-vous avec votre compte de fidélité`,
    'guest-identifier.name.loyalty-button': `Se connecter avec la fidélité`,
    'guest-identifier.name.loyalty-separator': `ou`,
    'guest-identifier.name.loyalty-error-title': `Oups ! Aucun nom trouvé`,
    'guest-identifier.name.loyalty-error-description': `Désolé, nous n'avons pas pu trouver de nom associé à ce compte. Veuillez saisir votre nom ci-dessous`,
    'inactivity-timer.button.continue': `Oui, j'ai besoin de plus de temps`,
    'inactivity-timer.button.exit': `Non, j'ai terminé`,
    'item-card.add.with-quantity': `Ajouter ({{$1: quantity}})`,
    'image.scan.default.alt': `Scannez votre code-barres ou QR code`,
    'loyalty.view_coupons': `Voir les coupons`,
    'loyalty.add_coupons': `Ajouter des coupons`,
    'loyalty.label.manual_redemption': `Code d'échange`,
    'loyalty.label.manual_redemption_instructions': `Saisissez votre code d'échange pour utiliser votre récompense`,
    'loyalty.label.welcome.new-user': `Bonjour, {{$1: user}} ! Vous avez maintenant un compte de fidélité`,
    'loyalty.reward_label.payment_unapplied': `Appliquer le paiement à la carte enregistrée`,
    'loyalty.reward_label.redeemable_unredeemed': `Échanger avec {{$1: points}} points`,
    'loyalty.reward_label.payment_at_checkout': `Le paiement peut être appliqué au moment du paiement`,
    'loyalty.reward_group_label.payment': `Récompenses de paiement`,
    'loyalty.rewards.payment-reward.name': `Payer avec le solde`,
    'loyalty.rewards.payment-reward.name-with-amount': `Payer avec le solde ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Votre solde actuel`,
    'loyalty.rewards.card-on-file-payment.description': `Le paiement sera débité de votre carte enregistrée.`,
    'loyalty.redemption_auth.back_to_rewards': `Retour aux récompenses`,
    'loyalty.redemption_auth.subtitle': `Scannez votre code-barres d'échange pour utiliser votre récompense`,
    'loyalty.redemption_auth.submit': `Échanger la récompense`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Saisissez votre nom`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Veuillez accepter les conditions générales pour continuer.`,
    'loyalty.checkout-signup.header': `Dernière chance de s'inscrire et de gagner des récompenses sur cette commande !`,
    'loyalty.checkout-signup.skip': `Ignorer et passer au paiement`,
    'loyalty.checkout-signup.success.new-account.title': `Nouveau compte créé`,
    'loyalty.checkout-signup.success.new-account.description': `Merci de nous rejoindre, vous gagnerez des récompenses sur cette commande !`,
    'loyalty.checkout-signup.success.existing-account.title': `Le compte existe déjà`,
    'loyalty.checkout-signup.success.existing-account.description': `Vous vous êtes déjà inscrit avec ce numéro. Vous êtes maintenant connecté.`,
    'loyalty.checkout-signup.error.title': `Erreur lors de la création du compte`,
    'loyalty.checkout-signup.error.description': `Une erreur s'est produite lors de la création du compte`,
    'loyalty.checkout-signup.error.skip': `Ignorer et passer au paiement`,
    'loyalty.checkout-signup.error.try-again': `Réessayer`,
    'menu.item.reset': `Réinitialiser l'article`,
    'menu.mod-group.quick-select': `Sélection rapide`,
    'menu.mod-group.quick-select-active': `Sélectionné`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Scannez des articles pour commencer à commander`,
    'menu.page.scanner.scanned.title': `Articles du panier`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Voir les articles scannés`,
    'order-history.button.add-to-order': `Ajouter les articles disponibles ({{$1: number}})`,
    'order-history.title': `Historique des commandes`,
    'order-history.subtitle': `Toutes vos commandes précédentes apparaîtront ici. Interagissez avec les articles pour les voir ou les ajouter à votre commande actuelle. Vous pouvez ajouter tous les articles d'une commande d'un seul geste.`,
    'order-history.next-page': `Suivant`,
    'order-history.previous-page': `Précédent`,
    'order-history.screen.close': `Fermer`,
    'order-history.screen.error.title': `Une erreur s'est produite`,
    'order-history.screen.error.subtitle': `Échec du chargement de l'historique des commandes. Veuillez réessayer plus tard.`,
    'order-history.screen.error.button.back': `Retour`,
    'order-history.screen.error.button.retry': `Réessayer`,
    'order-history.screen.no-orders': `Aucune commande précédente trouvée. Quand vous passerez une commande, revenez ici pour la voir.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Certains articles de cette commande ne sont pas disponibles pour une recommande rapide. Veuillez ajouter les articles en appuyant sur chacun individuellement.`,
    'order-history.section.button.view-all': `Voir plus de mes commandes`,
    'order-history.topbar.button.back': `Retour`,
    'loyalty.unapplicable_rewards_warning_title': `Récompenses non applicables`,
    'loyalty.unapplicable_rewards_warning_description': `Pour utiliser la récompense sélectionnée, veuillez ajouter les articles applicables à votre panier. La récompense et la réduction seront appliquées au moment du paiement.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Appliquer`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Saisie manuelle`,
    'loyalty.button.menu.authed': `Récompenses`,
    'loyalty.button.menu.unauthed': `Récompenses`,
    'loyalty.button.checkout.authed': `Récompenses`,
    'loyalty.button.checkout.unauthed': `Récompenses`,
    'loyalty.error.reward_failed_to_apply': `Échec de l'application de la récompense. Veuillez réessayer.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Ignorer et continuer vers le menu`,
    'loyalty.login-options.button.skip.checkout': `Ignorer et continuer vers le paiement`,
    'loyalty.login-options.button.skip.dining-option-collection': `Ignorer et continuer le paiement`,
    'loyalty.login-options.title': `Choisissez une option pour vous connecter ou continuer en tant qu'invité`,
    'loyalty.login-options.subtitle': `Vous pouvez toujours vous connecter plus tard`,
    'loyalty.login-options.signup.link': `Pas de compte ? Inscrivez-vous`,
    'loyalty.login-options.barcode.title': `Scanner un code-barres`,
    'loyalty.login-options.barcode.subtitle': `Scannez votre code-barres pour vous connecter`,
    'loyalty.login-options.email-phone-number.title': `E-mail et numéro de téléphone`,
    'loyalty.login-options.email-phone-number.subtitle': `Saisissez votre e-mail et votre numéro de téléphone pour vous connecter`,
    'loyalty.login-options.email-password.title': `E-mail et mot de passe`,
    'loyalty.login-options.email-password.subtitle': `Saisissez votre e-mail et votre mot de passe pour vous connecter`,
    'loyalty.login-options.username-password.title': `Nom d'utilisateur et mot de passe`,
    'loyalty.login-options.username-password.subtitle': `Saisissez votre nom d'utilisateur et votre mot de passe pour vous connecter`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Numéro de téléphone`,
    'loyalty.login-options.phone-number.subtitle': `Saisissez votre numéro de téléphone pour vous connecter`,
    'loyalty.login-options.card-number.title': `Numéro de carte`,
    'loyalty.login-options.card-number.subtitle': `Saisissez votre numéro de carte pour vous connecter`,
    'loyalty.login-options.email.title': `E-mail`,
    'loyalty.login-options.email.subtitle': `Saisissez votre e-mail pour vous connecter`,
    'loyalty.login-options.or': `OU`,
    'loyalty.login-options.popup.close': `Fermer`,
    'loyalty.error.or': `OU`,
    'loyalty.login-error.saved-form': `Les informations que vous avez soumises :`,
    'loyalty.login-error.try-again.button': `Réessayer`,
    'loyalty.otp.enter-code.title': `Saisissez le code que nous vous avons envoyé`,
    'loyalty.otp.sent-to.email': `Nous avons envoyé un code par e-mail à {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `Nous avons envoyé un code par SMS à {{$1: masked phone number}}`,
    'loyalty.otp.verify': `Vérifier`,
    'loyalty.otp.resend': `Renvoyer le code`,
    'loyalty.otp.code.error.invalid': `Ce code est incorrect. Veuillez réessayer.`,
    'loyalty.otp.send-error.message': `Nous n'avons pas pu associer exactement un compte à ces informations. Veuillez les vérifier et réessayer.`,
    'loyalty.login.fallback.phone-number.button': `Utiliser un numéro de téléphone à la place`,
    'loyalty.login.fallback.barcode.button': `Scanner un code-barres ou QR code à la place`,
    'loyalty.login.fallback.card-number.button': `Utiliser un numéro de carte à la place`,
    'loyalty.login.fallback.email.button': `Utiliser un e-mail à la place`,
    'loyalty.login.fallback.email-phone-number.button': `Utiliser un e-mail et numéro de téléphone à la place`,
    'loyalty.login.fallback.email-password.button': `Utiliser un e-mail et mot de passe à la place`,
    'loyalty.login.fallback.username-password.button': `Utiliser un nom d'utilisateur et mot de passe à la place`,
    'loyalty.login.auth-method.phone-number.title': `Numéro de téléphone`,
    'loyalty.login.auth-method.barcode.title': `Scanner un code-barres ou QR code`,
    'loyalty.login.auth-method.card-number.title': `Numéro de carte`,
    'loyalty.login.auth-method.email.title': `E-mail`,
    'loyalty.login.auth-method.email-phone-number.title': `E-mail et numéro de téléphone`,
    'loyalty.login.auth-method.email-password.title': `E-mail et mot de passe`,
    'loyalty.login.auth-method.username-password.title': `Nom d'utilisateur et mot de passe`,
    'vitrine.error.order_validation_failed': `Échec de la validation de la commande. Veuillez réessayer.`,
    'vitrine.error.handshake_failed': `Impossible de se connecter au kiosque. Veuillez contacter un membre du personnel.`,
    'vitrine.error.request_timeout': `Impossible de terminer la requête. Veuillez réessayer.`,
    'vitrine.error.request_aborted': `Impossible de terminer la requête. Veuillez réessayer.`,
    'vitrine.error.analytics_send_error': `Impossible d'envoyer les données analytiques. Veuillez réessayer.`,
    'vitrine.error.garcon_incompatible_build': `Impossible de se connecter au kiosque. Veuillez contacter un membre du personnel pour obtenir de l'aide.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `Votre compte est introuvable`,
    'vitrine.error.loyalty-login-no-matching-user-message': `Nous n'avons pas trouvé d'utilisateur avec les informations fournies.`,
    'vitrine.error.loyalty_not_enough_points': `Votre compte n'a pas suffisamment de points pour échanger les récompenses sélectionnées.`,
    'vitrine.error.order_total_above_max': `Le total de la commande a dépassé le maximum autorisé. Veuillez contacter un membre du personnel.`,
    'vitrine.error.empty_menu': `Le menu que vous avez sélectionné est actuellement vide. Veuillez essayer une autre option de restauration.`,
    'maitred.error.integration_bad_config': `Il semble y avoir un problème avec la configuration du kiosque. Veuillez contacter un membre du personnel.`,
    'checkout.done.expo_receipt.error': `Impossible d'imprimer le reçu. Veuillez réessayer.`,
    'checkout.done.expo_receipt.success': `Reçu envoyé ! Veuillez demander l'aide d'un membre de l'équipe.`,
    'checkout.done.print-receipt.out-of-paper': `L'imprimante n'a plus de papier. Veuillez vous adresser à un membre de l'équipe pour obtenir votre reçu.`,
    'refunder.viewing-results.button.cancel': `Annuler`,
    'refunder.viewing-results.button.refund-all': `Tout rembourser`,
    'refunder.viewing-results.button.view-transaction': `Voir les transactions`,
    'refunder.viewing-results.button.done': `Terminé`,
    'refunder.viewing-results.button.back': `Retour`,
    'refunder.viewing-results.button.search': `Rechercher une commande`,
    'refunder.viewing-results.refund-order.error-print-receipt': `La commande a été remboursée avec succès, mais nous n'avons pas pu imprimer le reçu. Veuillez réessayer d'imprimer.`,
    'refunder.viewing-results.refund-order.success': `La commande a été remboursée avec succès.`,
    'refunder.viewing-results.refund-order.error': `Échec du remboursement de la commande. Veuillez réessayer.`,
    'refunder.viewing-results.order.refunded': `Commande remboursée`,
    'refunder.viewing-results.order.total': `Total de la commande`,
    'refunder.search-form.button.back': `Retour`,
    'refunder.search-form.button.search': `Rechercher`,
    'refunder.viewing-order.title': `Toutes les transactions de la commande #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Veuillez sélectionner la transaction que vous souhaitez rembourser.`,
    'refunder.viewing-order.button.cancel': `Annuler`,
    'refunder.viewing-order.button.refund': `Rembourser`,
    'refunder.viewing-order.button.refund-partial': `Remboursement partiel`,
    'refunder.viewing-order.button.retry': `Réessayer`,
    'refunder.viewing-order.button.done': `Terminé`,
    'refunder.viewing-order.button.back': `Retour`,
    'refunder.viewing-order.refund-transaction.error': `Échec du remboursement de la transaction. Veuillez réessayer.`,
    'refunder.viewing-order.refund-transaction.success': `Transaction remboursée avec succès.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `La transaction a été remboursée avec succès, mais nous n'avons pas pu imprimer le reçu. Veuillez réessayer d'imprimer.`,
    'refunder.viewing-order.transaction.total': `Total`,
    'refunder.viewing-order.transaction.refunded': `Remboursé`,
    'refunder.viewing-order.error.title': `Erreur`,
    'refunder.viewing-order.error.message': `Échec du chargement de la commande. Veuillez réessayer.`,
    'refunder.viewing-order.error.button.retry': `Réessayer`,
    'refunder.viewing-order.error.button.back': `Retour`,
    'refunder.partial-transaction-refund.error.amount-too-high': `Le montant est trop élevé.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `Le montant est trop faible.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `Le montant n'est pas valide.`,
    'refunder.partial-transaction-refund.error.amount-required': `Le montant est requis.`,
    'refunder.partial-transaction-refund.error': `Un problème s'est produit lors du traitement du remboursement. Veuillez réessayer.`,
    'refunder.partial-transaction-refund.button.submit': `Soumettre le remboursement partiel`,
    'refunder.partial-transaction-refund.button.back': `Retour`,
    'refunder.partial-transaction-refund.title': `Remboursement partiel de transaction`,
    'refunder.partial-transaction-refund.hint': `Veuillez saisir le montant que vous souhaitez rembourser. Le montant maximum est {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Montant`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.group-ordering.actions.change-recipient': `Modifier le destinataire`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Attribuer l'article à`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Annuler`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Ajouter nouveau`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Réattribuer`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `Pour qui est cet article ?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Attribuer à cet invité`,
    'checkout.cart.starbucks-stars': `Article de {{$1: amount}} \u2605`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `Menu principal`,
    'menu.nav.starbucks.experiences': `Expériences`,
    'menu.nav.starbucks.wayfinder': `Explorer le lieu`,
    'menu.secret-menu.access-code.title': `Saisir le code d'accès`,
    'menu.secret-menu.access-code.button.back': `Retour`,
    'menu.secret-menu.access-code.button.submit': `Soumettre`,
    'menu.secret-menu.access-code.error': `Code d'accès invalide`,
    'menu.secret-menu.access-code.success': `Code d'accès accepté`,
    'menu.toast.added-to-cart': `Ajouté au panier`,
    'menu.toast.combo-savings': `Économies menu !`,
    'menu.toast.discount-applied': `Réduction appliquée !`,
    'menu.exit-verification.title': `Vérification du responsable requise`,
    'menu.exit-verification.description': `Un code d'accès employé est requis pour quitter. Veuillez demander l'aide d'un membre de l'équipe.`,
    'menu-item.starbucks-stars': `{{$1: amount}} \u2605`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Veuillez poser votre article sur la balance.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Pèse`,
    'menu-item.scale.price-per-unit': `{{$1: price}} par {{$2: unit}}`,
    'menu-item.scale.price': `Prix`,
    'menu-item.scale.instructions': `Utilisez la balance pour peser votre article. Pour réinitialiser, appuyez sur le bouton indiqué sur la balance.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Pesée en cours...`,
    'menu-item.scale.error-reading-weight': `Erreur lors de la lecture du poids. Veuillez réessayer.`,
    'menu-item.scale.error-no-weight': `Veuillez peser votre article si vous souhaitez l'ajouter à votre commande.`,
    'menu-item.scale.no-scale': `Aucune balance détectée. Veuillez contacter un membre du personnel.`,
    'also-consider.title': `Vous pourriez aussi aimer...`,
    'also-consider.back-to-item': `Retour à l'article`,
    'also-consider.add-to-order': `Ajouter à la commande`,
    'also-consider.skip-add-on': `Ignorer le complément`,
    'menu-item.assorted.title': `Composez votre assortiment`,
    'menu-item.assorted.count': `{{$1: count}} sur {{$2: total}} sélectionnés`,
    'menu-item.row-size-mod.option.none': `Aucun`,
    'menu-item.high-sugar-warning.description': `Avertissement : Cette icône indique que la teneur en sucres ajoutés de cet article est égale ou supérieure à la limite quotidienne totale recommandée de sucres ajoutés pour un régime de 2 000 calories (50 g). Consommer de grandes quantités de sucres ajoutés au fil du temps peut augmenter le risque de diabète de type 2, de prise de poids et de caries dentaires.`,
    'menu-item.high-sodium-warning.description': `Avertissement : Cette icône indique que la teneur en sodium (sel) de cet article est supérieure à la limite quotidienne totale recommandée (2 300 mg). Une consommation élevée de sodium peut augmenter la pression artérielle et le risque de maladie cardiaque et d'accident vasculaire cérébral.`,
    'menu-item.group-ordering.items-for': `Commande groupée - Articles pour :`,
    'menu-item.group-ordering.prompt.title': `Commander en groupe ?`,
    'menu-item.group-ordering.prompt.description': `L'option de commande groupée vous demandera à quel membre de votre groupe correspond chaque article. Appuyez sur « Oui » pour activer la commande groupée. Appuyez sur « Non » si vous souhaitez continuer avec cette option.`,
    'menu-item.group-ordering.prompt.button.accept': `Oui, commande groupée`,
    'menu-item.group-ordering.prompt.button.decline': `Non, merci`,
    'menu-item.group-ordering.add-recipient': `Ajouter nouveau`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Ajouter un nouveau destinataire`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Saisissez le nom du destinataire`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Attribuer à l'invité`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Annuler`,
    'menu-item.group-ordering.recipient-picker.title': `Pour qui est-ce ?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Ajouter nouveau`,
    'menu-item.nested-mod-groups.edit': `Modifier`,
    'menu-item.nested-mod-groups.popup.done': `Terminé`,
    'menu-item.nested-mod-groups.popup.cancel': `Annuler`,
    'menu-item.nested-mod-groups.popup.back': `Retour`,
    'menu-item.nested-mod-groups.popup.next': `Suivant`,
    'checkout.cart.remove-item-verification.title': `Vérification du responsable requise`,
    'checkout.cart.remove-item-verification.description': `Un code d'accès employé est requis pour supprimer cet article du panier. Veuillez demander l'aide d'un membre de l'équipe.`,
    'checkout.cart.confirm-remove-item.title': `Supprimer l'article ?`,
    'checkout.cart.confirm-remove-item.description': `Êtes-vous sûr de vouloir supprimer {{$1: item name}} de votre panier ?`,
    'checkout.cart.confirm-remove-item.cancel': `Annuler`,
    'checkout.cart.confirm-remove-item.confirm': `Supprimer`,
    'checkout.cart.pre-checkout-recommendations.title': `Complétez votre commande`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Continuer`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Retour`,
    'checkout.cart.item-86d.title.items': `Certains articles ne sont plus disponibles`,
    'checkout.cart.item-86d.title.mods': `Certaines modifications ne sont plus disponibles`,
    'checkout.cart.item-86d.title.mixed': `Certains articles et modifications ne sont plus disponibles`,
    'checkout.cart.item-86d.description.items': `Les articles suivants ont été supprimés de votre panier :`,
    'checkout.cart.item-86d.description.mods': `Les modifications suivantes ont été supprimées de vos articles :`,
    'checkout.cart.item-86d.description.mixed': `Les éléments suivants ne sont plus disponibles et ont été supprimés :`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (dans {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Modifier`,
    'checkout.payment-options.tip.invalid-tip-amount': `Désolé, vous ne pouvez pas appliquer un pourboire supérieur au total de la commande. Veuillez saisir un montant de pourboire inférieur au sous-total de la commande moins les réductions.`,
    'checkout.payment-options.name.title': `Bonjour, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Sélectionnez une méthode de carte-cadeau`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Carte-cadeau`,
    'checkout.payment-options.pay-with-cash-machine.label': `Appuyer pour payer avec la machine à espèces`,
    'checkout.payment-options.pay-with-cash-machine.button': `Espèces`,
    'checkout.payment-options.donation.or': `OU`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Informations sur les frais de service`,
    'checkout.payment-options.credit-card.button.zero-balance': `Passer la commande`,
    'checkout.payment-options.inline-loyalty.view-all': `Voir toutes les récompenses`,
    'checkout.payment-options.inline-loyalty.apply': `Appliquer les récompenses`,
    'checkout.payment-options.inline-loyalty.greeting': `Bonjour, {{$1: name}} !`,
    'checkout.payment-options.inline-loyalty.star-balance': `Solde d'étoiles : {{$1: stars}}\u2605`,
    'checkout.payment-options.inline-loyalty.celebration.title': `Joyeux anniversaire !`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `Joyeux anniversaire, {{$1: name}} !`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `Profitez de votre cadeau !`,
    'checkout.payment-options.inline-loyalty.error.title': `Impossible d'appliquer les récompenses`,
    'checkout.payment-options.inline-loyalty.error.message': `Une erreur s'est produite lors de l'application de vos récompenses. Veuillez réessayer.`,
    'loyalty.starbucks.header.redeemable-stars': `Étoiles échangeables`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}\u2605 expirant le {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Vos étoiles n'expireront pas`,
    'loyalty.starbucks.progress.next-status-by-date': `Gagnez {{$1: stars}}\u2605 avant le {{$2: date}} pour atteindre le niveau {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `Gagnez {{$1: stars}}\u2605 pour atteindre le niveau {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Gagnez {{$1: stars}}\u2605 avant le {{$2: date}} pour prolonger votre niveau {{$3: level}} d'une année supplémentaire`,
    'loyalty.starbucks.progress.maintain-status': `Gagnez {{$1: stars}}\u2605 pour prolonger votre niveau {{$2: level}} d'une année supplémentaire`,
    'loyalty.starbucks.progress.extended': `Prolongé d'une année supplémentaire`,
    'loyalty.starbucks.progress.annual-earned': `Gagnées cette année`,
    'loyalty.starbucks.progress.status-target': `Niveau {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `pour prolonger`,
    'loyalty.starbucks.birthday.title': `Joyeux anniversaire, {{$1: name}} !`,
    'loyalty.starbucks.birthday.title-no-name': `Joyeux anniversaire !`,
    'loyalty.starbucks.birthday.redeem': `Utilisez votre coupon d'anniversaire !`,
    'loyalty.starbucks.birthday.description': `Profitez de votre boisson ou gourmandise préférée, offerte par nous. Utilisez-le au moment du paiement, ou informez votre barista lors de la commande.`,
    'loyalty.starbucks.birthday.valid-until': `Valide jusqu'au {{$1: date}}`,
    'loyalty.starbucks.member-since': `Membre depuis {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Merci d'être un membre fidèle de Starbucks Rewards.`,
    'checkout.paying.starbucks.title': `Veuillez scanner maintenant le QR code dans votre application Starbucks`,
    'checkout.paying.starbucks.subtitle': `Veuillez vous assurer que la fonction Scan to Pay est prête dans votre application Starbucks pour finaliser votre commande.`,
    'checkout.paying.starbucks.cancel-button': `Annuler`,
    'checkout.paying.error.loyalty-payment': `Désolé, nous n'avons pas pu traiter votre paiement. Veuillez réessayer.`,
    'checkout.paying.error.pos.print': `Continuer et imprimer le reçu`,
    'checkout.paying.error.table-tracker.print': `Continuer et imprimer le reçu`,
    'checkout.paying.error.table-tracker.title': `Oups ! Nous n'avons pas pu obtenir votre traceur.`,
    'checkout.paying.error.table-tracker.instructions': `Votre commande a été traitée, mais une erreur s'est produite lors de la distribution de votre traceur de table pour suivre votre commande. Passez à l'étape suivante pour recevoir votre reçu.`,
    'checkout.paying.error.title': `Oups !`,
    'checkout.paying.sending-table-tracker-request.title': `Distribution du traceur`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Veuillez patienter pendant que nous distribuons votre traceur de table.`,
    'checkout.paying.cash-machine.pinging.title': `Vérification de la machine à espèces`,
    'checkout.paying.cash-machine.pinging.subtitle': `Veuillez patienter pendant que nous vérifions si la machine à espèces est disponible.`,
    'checkout.paying.cash-machine.awaiting.title': `Machine à espèces en cours d'utilisation`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Veuillez patienter jusqu'à ce que la machine à espèces soit disponible.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Annuler`,
    'checkout.paying.cash-machine.receiving.title': `Machine à espèces prête`,
    'checkout.paying.cash-machine.receiving.subtitle': `Veuillez insérer votre paiement dans la machine à espèces.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Annuler`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Annuler et rembourser le paiement`,
    'checkout.paying.cash-machine.receiving.partial-button': `Payer le reste autrement`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} restant`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Veuillez prendre tous les billets et pièces de la machine à espèces.`,
    'checkout.paying.cash-machine.cancelling.title': `Annulation du paiement par machine à espèces`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Veuillez prendre tous les billets et pièces de la machine à espèces.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Erreur lors de l'annulation du paiement par machine à espèces`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `Votre paiement n'a pas pu être annulé. Veuillez demander l'aide d'un membre de l'équipe.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Continuer et imprimer le reçu`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Monnaie insuffisante`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `La machine à espèces n'a pas pu vous rendre la monnaie pour votre paiement, nous avons donc remboursé votre paiement.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Réessayer`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Retour`,
    'checkout.paying.cash-machine.error.message': `La machine à espèces n'a pas pu traiter votre paiement. Veuillez réessayer.`,
    'checkout.done.details.guest-name': `Nom`,
    'checkout.done.details.table-number': `Numéro de table`,
    'checkout.done.details.tracker-number': `Numéro de suivi`,
    'checkout.done.details.order-number': `Numéro de commande`,
    'checkout.done.error.table-tracker.instructions': `Une erreur s'est produite lors de la récupération de votre traceur. Votre commande a été traitée avec succès. Veuillez demander l'aide d'un employé.`,
    'checkout.done.qr-code.error': `Désolé, nous n'avons pas pu générer de QR code pour votre reçu.`,
    'printer-receipt.stored-value-remaining-balance': `Solde restant de {{$1: label}}`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `L'option de restauration que vous avez sélectionnée n'est plus disponible. Votre commande a été mise à jour pour utiliser « {{$1: dining option name}} ».`,
    'order-reconciler.error.items-unavailable': `Certains articles de votre commande ne sont plus disponibles. Votre commande a été mise à jour pour supprimer les articles indisponibles. Les articles suivants ont été supprimés : {{$1: item names}}`,
    'page-nav.order-history-item.title': `Vos commandes`,
    'page-nav.order-history-item.cta': `Voir mes commandes`,
    'print.error.phone-number-label': `Numéro de téléphone`,
    'print.error.guest-name-label': `Nom`,
    'print.error.table-number-label': `Numéro de table`,
    'print.error.tracker-number-label': `Numéro de suivi`,
    'print.error.order-number-label': `Numéro de commande`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.fr-ca.js.map